import type { IObjectiveNeedsAndObjectives } from './ObjectiveNeedsAndObjectives.interface';

export default class ObjectiveNeedsAndObjectives implements IObjectiveNeedsAndObjectives {
  notes: string;
  loanAmount: number;
  loanTerm: number;
  immediateNeedsAndObjectivesNotes: string;
  longerTermNotes: string;

  static build = (data: IObjectiveNeedsAndObjectives) => new ObjectiveNeedsAndObjectives(data);
  static blank = () => new ObjectiveNeedsAndObjectives();

  /**
   * Constructor
   * @param {IObjectiveNeedsAndObjectives} data
   */
  constructor(data?: IObjectiveNeedsAndObjectives) {
    this.notes = data?.notes || '';
    this.loanAmount = parseFloat(data?.loanAmount || 0);
    this.loanTerm = parseFloat(data?.loanTerm || 0);
    this.immediateNeedsAndObjectivesNotes = data?.immediateNeedsAndObjectivesNotes || '';
    this.longerTermNotes = data?.longerTermNotes || '';
  }
}
